import {Injectable} from '@angular/core';
import {HttpInterceptorService} from "../../core/services/http-interceptor.service";
import {Observable} from "rxjs/Observable";
import {ICurationCreateRequest} from "../interfaces/curation-create-request.interface";

@Injectable()
export class ClinicalTrialMatchService {

  public static baseUrl = '/ClinicalTrialMatch';

  constructor(private _http: HttpInterceptorService) {
  }

    public getTrialFromEs( trialId:string): Observable<any> {
    let req = this._http.get(ClinicalTrialMatchService.baseUrl + '/getTrialFromEs/' + trialId ,true)
      .map(data => {
        let res = data;
        return res;
      }).catch(err => {
        return Observable.of(err);
      })
      .publish();
    req.connect();
    return req;
  }
}
